import React, { FC } from "react";
import styled from "styled-components";

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Logo = styled.img`
  margin-right: .5rem;
  height: 1.5rem;
  object-fit: contain;
`;

const AppName = styled.span`
  align-self: flex-end;
  font-weight: 700;
  font-size: .625rem;
`;

interface Props {
  appName: string;
  onHeaderLogoClick?: () => void;
}

export const AppLogoHeader: FC<Props> = ({ appName, onHeaderLogoClick }) => {
	return (
		<LogoWrapper onClick={onHeaderLogoClick} style={{ cursor: onHeaderLogoClick ? 'pointer' : 'default' }}>
			<Logo src={'dew21_logo.svg'} alt={'DEW21 Logo'} />
			<AppName>{appName}</AppName>
		</LogoWrapper>
	)
}
